import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { shouldSkipLandingPageHostedAssets } from '../../util/marketingSiteRedirect';

export const ASSET_NAME = 'landing-page';

export const loadData = (params, search) => dispatch => {
  const hash =
    typeof window !== 'undefined' && window.location && window.location.hash
      ? window.location.hash
      : '';
  if (shouldSkipLandingPageHostedAssets(search || '', hash)) {
    return Promise.resolve();
  }
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
